import { useEffect, useState } from "react";
import { VALIDATION_ERROR } from "../../app/errors";
import { ErrorWithString } from "../../components/RegularComponents";

const MRARJSCCompanyOfficialForm = (props) => {
  const { firstName, lastName, role, index, onSaveItem, validationError } =
    props;

  const [officialFirstname, setOfficialFirstname] = useState(firstName);
  const [officialLastname, setOfficialLastname] = useState(lastName);
  const [officialRole, setOfficialRole] = useState(role);

  const [showValidationError, setShowValidationError] =
    useState(validationError);

  const [officialFirstnameError, setOfficialFirstnameError] = useState(
    VALIDATION_ERROR.NO_ERROR
  );
  const [officialLastnameError, setOfficialLastnameError] = useState(
    VALIDATION_ERROR.NO_ERROR
  );

  useEffect(() => {
    const validateFirstname = () => {
      if (!officialFirstname) {
        setOfficialFirstnameError(VALIDATION_ERROR.EMPTY);
      } else {
        setOfficialFirstnameError(VALIDATION_ERROR.NO_ERROR);
      }
    };

    const validateLastname = () => {
      if (!officialLastname) {
        setOfficialLastnameError(VALIDATION_ERROR.EMPTY);
      } else {
        setOfficialLastnameError(VALIDATION_ERROR.NO_ERROR);
      }
    };

    if (showValidationError) {
      validateFirstname();
      validateLastname();
    }
  }, [
    officialFirstname,
    officialLastname,
    officialFirstnameError,
    officialLastnameError,
    showValidationError,
  ]);

  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <fieldset className="ns-fieldset"></fieldset>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id={"company-official-firstName-label"}
              className="ns-label"
              htmlFor={"company-official-firstName-text"}
            >
              First Name
            </label>
            {officialFirstnameError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"company-official-firstName-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(officialFirstnameError)}
              </span>
            )}
            <input
              type="text"
              className={"fw-25 ns-input"}
              id={"company-official-firstName-text"}
              name={"company-official-firstName-text"}
              value={officialFirstname}
              onChange={(e) => {
                setOfficialFirstname(e.target.value);
              }}
              onBlur={() => {
                setShowValidationError(true);
                onSaveItem(index, officialFirstname, "firstName");
              }}
            />
          </fieldset>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id={"company-official-lastName-label"}
              className="ns-label"
              htmlFor={"company-official-lastName-text"}
            >
              Last Name
            </label>
            {officialLastnameError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"company-official-lastName-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(officialFirstnameError)}
              </span>
            )}
            <input
              type="text"
              className={"fw-25 ns-input"}
              id={"company-official-lastName-text"}
              name={"company-official-lastName-text"}
              value={officialLastname}
              onChange={(e) => {
                setOfficialLastname(e.target.value);
              }}
              onBlur={() => {
                setShowValidationError(true);
                onSaveItem(index, officialLastname, "lastName");
              }}
            />
          </fieldset>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8">
          <fieldset>
            <div className="ns-field-set fw-25">
              <label
                className="ns-label"
                id={"company-official-role-select-label"}
                htmlFor={"company-official-role-select-input"}
              >
                Role with company
              </label>
              <div className="select fw-20 inlineDisplay">
                <select
                  style={{ width: "20em" }}
                  id={"company-official-role-select-input"}
                  name={"company-official-role-select-input"}
                  value={officialRole}
                  onChange={(e) => {
                    setOfficialRole(e.target.value);
                    setShowValidationError(true);
                    onSaveItem(index, e.target.value, "position");
                  }}
                >
                  <option key={`select-option-director`} value={"Director"}>
                    Director
                  </option>
                  <option key={`select-option-officer`} value={"Officer"}>
                    Officer
                  </option>
                  <option key={`select-option-partner`} value={"Partner"}>
                    Partner
                  </option>
                  <option
                    key={`select-option-soleProprietor`}
                    value={"soleProprietor"}
                  >
                    Sole Proprietor
                  </option>
                </select>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </>
  );
};

export default MRARJSCCompanyOfficialForm;
